module.exports = __webpack_public_path__ + "static/media/Notification.74ce7328.svg";